var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71436 0V0.857138H10.5429L7.20007 4.19998L7.80007 4.79997L11.1429 1.45713V4.28569H12V0H7.71436Z",
    fill: "#1D1D1D",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 9.98556C10.2857 10.6284 9.77144 11.1427 9.12859 11.1427H2.01434C1.37149 11.1427 0.857206 10.6284 0.857206 9.98556V2.87131C0.857206 2.22846 1.37149 1.71418 2.01434 1.71418H6.8571V0.85704H2.01434C0.900063 0.85704 0 1.75704 0 2.87138V9.98563C0 11.0999 0.899995 12 2.01434 12H9.12859C10.2429 12 11.1429 11.1 11.1429 9.98563V5.14287H10.2858L10.2857 9.98556Z",
    fill: "#1D1D1D",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.b75fc1a77cf5250d8f0e40b850e59b0c.svg";
export { ForwardRef as ReactComponent };